<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.comprovantes.tituloLabel" />
      <v-divider />

      <template>
        <div class="text-center">
          <v-chip
            class="ma-2"
            :color="type.cor"
            :outlined="typeReceipt != type.id"
            :text-color="typeReceipt == type.id ? 'white' : ''"
            @click="filtrarPorTipoComprovante(type.id)"
            v-for="type in typesReceipts"
            :key="type.id"
          >
            <v-avatar left>
              <v-icon> {{ type.icone }} </v-icon>
            </v-avatar>
            {{ type.nome }}
          </v-chip>
        </div>
      </template>

      <template>
        <v-row justify="space-around">
          <v-col
            cols="12"
            sm="8"
            md="6"
          >
            <v-skeleton-loader
              :loading="loadingPeriodos"
              transition="scale-transition"
              height="80"
              :types="{ skeleton: 'list-item' }"
              type="skeleton"
            >
              <v-slide-group show-arrows>
                <v-chip-group
                  mandatory
                  active-class="white--text primary "
                  v-model="filterPeriod"
                >
                  <v-chip
                    v-for="option in filterOptions"
                    :key="option.descricao"
                    @click="aplicaFiltroPorPeriodo(option)"
                  >
                    {{ option.descricao }}
                  </v-chip>
                </v-chip-group>
              </v-slide-group>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </template>

      <template v-if="!showError">
        <v-row justify="center">
          <v-col
            cols="12"
            lg="3"
            md="6"
          >
            <v-skeleton-loader
              :loading="loading"
              transition="scale-transition"
              max-width="344"
              :types="{ skeleton: 'card' }"
              type="skeleton"
            >
              <div class="d-flex justify-center">
                <v-card
                  class="mx-2 pa-2"
                  max-width="344"
                >
                  <v-card-text class="d-flex flex-column fill-height justify-space-between align-center">
                    <p class="display-1 text--primary">
                      {{ locale[local].screen.comprovantes.string001 }}
                      {{ referenciaPeriodoSelecionado }}
                      <!-- {{ filterOptions[filterPeriod].descricao }} -->
                    </p>

                    <div class="text--primary">
                      {{ locale[local].screen.comprovantes.string002 }}
                      <b> {{ typesReceipts[typeReceipt].nome }} </b>
                      {{ locale[local].screen.comprovantes.string003 }}
                    </div>

                    <v-tooltip bottom="">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="primary"
                          class="ma-2 white--text"
                          :href="
                            'data:application/octet-stream;base64,' +
                            getBase64PDF()
                          "
                          download="comprovante.pdf"
                          :disabled="showError || loading"
                          width="200"
                          max-width="200"
                        >
                          <span>
                            {{ locale[local].screen.comprovantes.string004 }}
                          </span>
                          <v-icon
                            right
                            medium
                          > mdi-printer </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        locale[local].screen.comprovantes.string005
                      }}</span>
                    </v-tooltip>
                  </v-card-text>
                </v-card>

                <v-card
                  class="mx-2 pa-2"
                  max-width="344"
                  v-if="planoSaude && planoSaude != ''"
                >
                  <v-card-text class="d-flex flex-column fill-height justify-space-between align-center">
                    <v-icon
                      size="70"
                      color="red"
                    >mdi-chart-box</v-icon>

                    <div class="text--primary">
                      Extrato do
                      <b> Plano de saúde </b>
                    </div>

                    <v-btn
                        color="primary"
                        class="ma-2 white--text"
                        :href="
                            'data:application/octet-stream;base64,' +
                            getBase64PDFPlanoSaude()
                          "
                        download="plano_saude.pdf"
                        :disabled="showError || loading"
                        width="200"
                        max-width="200"
                      >
                        <span>
                          {{ locale[local].screen.comprovantes.string004 }}
                        </span>
                        <v-icon
                          right
                          medium
                        > mdi-printer </v-icon>
                      </v-btn>
                  </v-card-text>
                  <!-- <v-card-actions class="justify-center">
                   
                  </v-card-actions> -->
                </v-card>

                <v-card
                  class="mx-2 pa-2"
                  max-width="344"
                  v-if="comissao && comissao != ''"
                >
                  <v-card-text class="d-flex flex-column fill-height justify-space-between align-center">
                    <v-icon
                      size="70"
                      color="orange"
                    >mdi-currency-usd</v-icon>

                    <div class="text--primary">
                      Extrato de
                      <b> Comissões </b>
                    </div>

                    <v-btn
                        color="primary"
                        class="ma-2 white--text"
                        :href="
                            'data:application/octet-stream;base64,' +
                            getBase64PDFComissao()
                          "
                        download="comissoes.pdf"
                        :disabled="showError || loading"
                        width="200"
                        max-width="200"
                      >
                        <span>
                          {{ locale[local].screen.comprovantes.string004 }}
                        </span>
                        <v-icon
                          right
                          medium
                        > mdi-printer </v-icon>
                      </v-btn>
                  </v-card-text>
                  <!-- <v-card-actions class="justify-center">
                   
                  </v-card-actions> -->
                </v-card>

                <v-card
                  class="ml-4"
                  max-width="344"
                  v-if="empregado2.length > 0"
                >
                  <v-card-text>
                    <p class="display-1 text--primary">
                      {{ locale[local].screen.comprovantes.string001 }}
                      {{ referenciaPeriodoSelecionado }}
                    </p>

                    <div class="text--primary">
                      {{ locale[local].screen.comprovantes.string002 }}
                      <b> {{ typesReceipts[typeReceipt].nome }} </b>
                      {{ locale[local].screen.comprovantes.string003 }}
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                    <v-tooltip bottom="">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="primary"
                          class="ma-2 white--text"
                          :href="
                            'data:application/octet-stream;base64,' +
                            getBase64PDF2()
                          "
                          download="comprovante.pdf"
                          :disabled="showError || loading"
                          width="200"
                          max-width="200"
                        >
                          <span>
                            {{ locale[local].screen.comprovantes.string004 }}
                          </span>
                          <v-icon
                            right
                            medium
                          > mdi-printer </v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        locale[local].screen.comprovantes.string005
                      }}</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </div>
            </v-skeleton-loader>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            md="6"
            v-show="typeReceipt == 2"
          >
            <v-skeleton-loader
              :loading="loading"
              transition="scale-transition"
              max-width="344"
              :types="{ skeleton: 'card' }"
              type="skeleton"
            >
              <v-card
                class="mx-auto"
                max-width="344"
              >
                <v-card-text>
                  <p class="display-1 text--primary">
                    {{ locale[local].screen.comprovantes.string001 }}
                    {{ referenciaPeriodoSelecionado }}
                    <!-- {{ filterOptions[filterPeriod].descricao }} -->
                  </p>

                  <div class="text--primary">
                    <b> {{ typesReceipts[typeReceipt].nome }} </b>
                    {{ locale[local].screen.comprovantes.string003 }}
                  </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="primary"
                        class="ma-2 white--text"
                        @click="getComprovanteFerias"
                        :disabled="showError || loading"
                        width="200"
                        max-width="200"
                      >
                        <span>
                          {{ locale[local].screen.comprovantes.string004 }}
                        </span>
                        <v-icon
                          right
                          medium
                        > mdi-printer </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      locale[local].screen.comprovantes.string005
                    }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <div class="mx-auto mt-8 mb-4">
          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string006 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados proventos text-right">
                        {{
                          totalProventos
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="pt-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="80"
                :types="{ skeleton: 'list-item@2' }"
                type="skeleton"
              >
                <table
                  style="width: 100%"
                  class="px-4"
                >
                  <tr
                    v-for="provento in proventos"
                    :key="provento.codEvento"
                    style="height: 35px"
                  >
                    <td class="text-dados text-left">
                      {{ provento.nomeEvento }}
                    </td>
                    <td class="text-dados text-right">
                      {{ provento.hrMovto !== 0 ? provento.hrMovto : "" }}
                    </td>
                    <td class="text-dados text-right">
                      {{
                        provento.vlrMovto
                          | currency("R$", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                            spaceBetweenAmountAndSymbol: true,
                          })
                      }}
                    </td>
                  </tr>
                </table>
                <!-- <v-list
                dense
                class="py-0"
              >
                <v-list-item
                  v-for="provento in proventos"
                  :key="provento.codEvento"
                >
                  <v-list-item-content class="py-0">
                    <span class="text-dados text-left">
                      {{ provento.nomeEvento }}
                    </span>

                  </v-list-item-content>
                  <v-list-item-content
                    class="py-0"
                    style="width: 20px"
                  >
                    <span class="text-dados text-left">
                      {{ provento.hrMovto }}
                    </span>

                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <span class="text-dados text-right">
                      {{
                        provento.vlrMovto
                          | currency("R$", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                            spaceBetweenAmountAndSymbol: true
                          })
                      }}
                    </span>
                  </v-list-item-action>
                </v-list-item>
              </v-list> -->
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string007 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados descontos text-right">
                        {{
                          totalDescontos
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="pt-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="80"
                :types="{ skeleton: 'list-item@2' }"
                type="skeleton"
              >
                <table
                  style="width: 100%"
                  class="px-4"
                >
                  <tr
                    v-for="desconto in descontos"
                    :key="desconto.codEvento"
                    style="height: 35px"
                  >
                    <td class="text-dados text-left">
                      <v-icon
                        class="pb-2"
                        color="orange"
                        small
                        v-if="desconto.detalhamento != ''"
                        @click="mostraDetalhamento(desconto)"
                      >mdi-file-document</v-icon>
                      {{ desconto.nomeEvento }}
                    </td>
                    <td class="text-dados text-right">
                      {{ desconto.hrMovto !== 0 ? desconto.hrMovto : "" }}
                    </td>
                    <td class="text-dados text-right">
                      {{
                        desconto.vlrMovto
                          | currency("R$", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                            spaceBetweenAmountAndSymbol: true,
                          })
                      }}
                    </td>
                  </tr>
                </table>
                <!-- <v-list
                dense
                class="py-0"
              >
                <v-list-item
                 
                >
                  <v-list-item-content class="py-0">
                    <span class="text-dados text-left">
                      {{ desconto.nomeEvento }}
                    </span>
                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <span class="text-dados text-right">
                      {{
                        desconto.vlrMovto
                          | currency("R$", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                            spaceBetweenAmountAndSymbol: true
                          })
                      }}
                    </span>
                  </v-list-item-action>
                </v-list-item>
              </v-list> -->
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string008 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados liquido text-right">
                        {{
                          totalLiquido
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around" v-show="baseFGTS > 0">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string011 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados baseFGTS text-right">
                        {{
                          baseFGTS
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around" v-show="valorFGTS > 0">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string012 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados valorFGTS text-right">
                        {{
                          valorFGTS
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </div>

        <div
          class="mx-auto mt-8 mb-4"
          v-if="empregado2.length > 0"
        >
          <v-divider></v-divider>
          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string006 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados proventos text-right">
                        {{
                          totalProventos2
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="pt-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="80"
                :types="{ skeleton: 'list-item@2' }"
                type="skeleton"
              >
                <table
                  style="width: 100%"
                  class="px-4"
                >
                  <tr
                    v-for="provento in proventos2"
                    :key="provento.codEvento"
                    style="height: 35px"
                  >
                    <td class="text-dados text-left">
                      {{ provento.nomeEvento }}
                    </td>
                    <td class="text-dados text-right">
                      {{ provento.hrMovto !== 0 ? provento.hrMovto : "" }}
                    </td>
                    <td class="text-dados text-right">
                      {{
                        provento.vlrMovto
                          | currency("R$", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                            spaceBetweenAmountAndSymbol: true,
                          })
                      }}
                    </td>
                  </tr>
                </table>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string007 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados descontos text-right">
                        {{
                          totalDescontos2
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="pt-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="80"
                :types="{ skeleton: 'list-item@2' }"
                type="skeleton"
              >
                <table
                  style="width: 100%"
                  class="px-4"
                >
                  <tr
                    v-for="desconto in descontos2"
                    :key="desconto.codEvento"
                    style="height: 35px"
                  >
                    <td class="text-dados text-left">
                      <v-icon
                        class="pb-2"
                        color="orange"
                        small
                        v-if="desconto.detalhamento != ''"
                        @click="mostraDetalhamento(desconto)"
                      >mdi-file-document</v-icon>
                      {{ desconto.nomeEvento }}
                    </td>
                    <td class="text-dados text-right">
                      {{ desconto.hrMovto !== 0 ? desconto.hrMovto : "" }}
                    </td>
                    <td class="text-dados text-right">
                      {{
                        desconto.vlrMovto
                          | currency("R$", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                            spaceBetweenAmountAndSymbol: true,
                          })
                      }}
                    </td>
                  </tr>
                </table>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col
              cols="12"
              md="6"
              class="py-0"
            >
              <v-skeleton-loader
                :loading="loading"
                transition="scale-transition"
                height="52"
                :types="{ skeleton: 'table-heading' }"
                type="skeleton"
              >
                <v-list
                  dense
                  class="py-0"
                >
                  <v-list-item>
                    <v-list-item-content>
                      <span class="text-dados-titulo text-left">
                        {{ locale[local].screen.comprovantes.string008 }}
                      </span>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="text-dados liquido text-right">
                        {{
                          totalLiquido2
                            | currency("R$", 2, {
                              thousandsSeparator: ".",
                              decimalSeparator: ",",
                              spaceBetweenAmountAndSymbol: true,
                            })
                        }}
                      </span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
      </template>

      <template v-if="showError">
        <v-row justify="space-around">
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-card
              class="mx-auto"
              max-width="344"
            >
              <v-card-text>
                <p class="headline text--primary">Erro:</p>

                <div class="subtitle-1 text--primary">
                  {{ errorMessage }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-content>

    <v-dialog
      v-model="dialogDetalhamento"
      width="900"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >{{ locale[local].screen.comprovantes.string009 }}
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="dialogDetalhamento = false"
          >{{
            locale[local].screen.comprovantes.string010
          }}</v-btn>
        </v-card-title>
        <v-container>
          <div class="text-left">
            <template v-for="(item, index) in detalhamentos">
              <div
                :key="index"
                class="py-1"
              >
                {{ item }}
                <v-divider></v-divider>
              </div>
            </template>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import moment from "moment";
import Service from "@/components/api/Service";

export default {
  data() {
    return {
      service: new Service(),
      showError: false,
      errorMessage: "",
      dialogDetalhamento: false,
      drawer: null,
      show: false,
      typeReceipt: 0,
      filterPeriod: 0,
      filterOptions: [],
      typesReceipts: [
        {
          id: 0,
          nome: "ContraCheques",
          cor: "#00b297",
          icone: "mdi-cash",
          codTipoCalculo: 10,
        },
        {
          id: 1,
          nome: "13º",
          cor: "#dc3545",
          icone: "mdi-cash-plus",
          codTipoCalculo: 60,
        },
        {
          id: 2,
          nome: "Férias",
          cor: "#0866C6",
          icone: "mdi-beach",
          codTipoCalculo: 40,
        },

        //Se for Cliente ICON é adicionado esse trecho no lifecycle created()
        /* {
          id: 4,
          nome: "PLR",
          cor: "#8E24AA",
          icone: "mdi-domain",
          codTipoCalculo: 84,
        }, */
      ],
      totalProventos: 0,
      totalDescontos: 0,
      totalLiquido: 0,
      baseFGTS: 0,
      valorFGTS:0,
      proventos: [],
      descontos: [],
      detalhamentos: [],
      empregado1: [],
      empregado2: [],
      totalProventos2: 0,
      totalDescontos2: 0,
      totalLiquido2: 0,
      proventos2: [],
      descontos2: [],
      detalhamentos2: [],
      /*       totalProventos: 0,
      totalDescontos: 0,
      totalLiquido: 0,
      proventos: [],
      descontos: [],
      detalhamentos: [], */
      receiptBase64PDF: "",
      receiptBase64PDF2: "",
      referenciaPeriodoSelecionado: "",

      //Loadings
      loading: false,
      loadingPeriodos: false,
      comissao: null,
      planoSaude: null,
    };
  },
  created() {
    moment.locale("pt-br");
    if (process.env.VUE_APP_CLIENTE !== "STARA" && process.env.VUE_APP_CLIENTE !== "TRITEC") {
      this.typesReceipts.push({
        id: 3,
        nome: "Adiantamento Quinzenal",
        cor: "#E49B0F",
        icone: "mdi-currency-usd",
        codTipoCalculo: 80,
      });
    }

    if (process.env.VUE_APP_CLIENTE == "ICON" || process.env.VUE_APP_CLIENTE == "USIPE" || process.env.VUE_APP_CLIENTE == "STARA" || process.env.VUE_APP_CLIENTE == "CGI") {
      this.typesReceipts.push({
        id: process.env.VUE_APP_CLIENTE == "STARA" ? 3: 4,
        nome: "PLR",
        cor: "#8E24AA",
        icone: "mdi-domain",
        codTipoCalculo: 84,
      });
    }

    //this.populateFilers(-13, -3);
    //this.inicializaFiltros();
    this.filtrarPorTipoComprovante(0);
  },
  methods: {
    replace(val) {
      if (val === 0) {
        return "00:00";
      }
      const [hora, minuto] = val.toString().split(".");

      if (parseInt(hora) === 0) {
        return `00:${minuto}`;
      }

      if (parseInt(minuto) === 0) {
        return `${hora}:00`;
      }

      if (!minuto) {
        return `${hora}:00`;
      }
      return `${hora}:${minuto}`;
    },
    moment: function () {
      return moment();
    },
    async filtrarPorTipoComprovante(filter) {
      this.typeReceipt = filter;
      this.loading = true;
      this.loadingPeriodos = true;

      try {
        var codTipoCalculo =
          this.typesReceipts[this.typeReceipt].codTipoCalculo;

        var resposta = await this.service.buscaCompetencia({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          codTipoCalculo: codTipoCalculo,
        });

        if (resposta.status === 200) {
          if (resposta.data.retorno) {
            if (resposta.data.retorno[0].estatus === "Erro") {
              throw new Error(resposta.data.retorno[0].msgErro);
            }
          }

          var periodos = resposta.data.ttCompetencia;

          periodos.sort(function (a, b) {
            if (a.dtCompetencia < b.dtCompetencia) {
              return -1;
            }
            if (a.dtCompetencia > b.dtCompetencia) {
              return 1;
            }
            return 0;
          });

          periodos.reverse();

          // Necessária essa validação pois a API não valida se o mês atual possui comprovante gerado.
          if (codTipoCalculo == 10 && periodos.length > 0) {
            let periodo = moment(periodos[0].dtCompetencia);

            var response = await this.service.buscaMovimento({
              codPessoa: parseInt(localStorage.getItem("codPessoa")),
              mes: parseInt(periodo.format("M")),
              ano: parseInt(periodo.format("YYYY")),
              codTipoCalculo: codTipoCalculo,
            });

            if (response.status === 200) {
              if (response.data.retorno) {
                if (response.data.retorno[0].estatus === "Erro") {
                  periodos.shift();
                }
              }
            }
          }

          this.popularFiltros(periodos);
          this.loadingPeriodos = false;
        } else {
          throw new Error();
        }
      } catch (e) {
        this.loadingPeriodos = false;
        console.log(e);
      }

      //this.initialSetFilter();
      this.filterPeriod = 0;
      var filtroSelecionado = this.filterOptions[0];
      this.aplicaFiltroPorPeriodo(filtroSelecionado);
    },
    async aplicaFiltroPorPeriodo(filtroSelecionado) {
      var codTipoCalculo = this.typesReceipts[this.typeReceipt].codTipoCalculo;

      this.referenciaPeriodoSelecionado = filtroSelecionado.descricao;

      if (codTipoCalculo == 40) {
        this.getReceipt(
          filtroSelecionado.mes,
          filtroSelecionado.ano,
          codTipoCalculo,
          filtroSelecionado.dia
        );
      } else {
        this.getReceipt(
          filtroSelecionado.mes,
          filtroSelecionado.ano,
          codTipoCalculo
        );
      }
    },
    async getComprovanteFerias() {
      const { mes, ano } = this.filterOptions[0];
      var response = await this.service.buscaMovimento({
        codPessoa: parseInt(localStorage.getItem("codPessoa")),
        mes: parseInt(mes),
        ano: parseInt(ano),
        codTipoCalculo: 41,
      });

      if (response.status === 200) {
        if (response.data.retorno) {
          if (response.data.retorno[0].estatus === "Erro") {
            throw new Error(response.data.retorno[0].msgErro);
          }
        }

        const linkSource = `data:application/octet-stream;base64,${response.data.ttMovimento[0].anexo}`;
        const downloadLink = document.createElement("a");
        const fileName = "comprovante_ferias.pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

        this.loading = false;
      } else {
        throw new Error();
      }
    },
    async getReceipt(mes, ano, codTipoCalculo, dia) {
      try {
        this.cleanErrorMessage();

        this.loading = true;

        var response = await this.service.buscaMovimento({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          mes: parseInt(mes),
          ano: parseInt(ano),
          codTipoCalculo: codTipoCalculo,
          dia: dia,
        });

        if (response.status === 200) {
          if (response.data.retorno) {
            if (response.data.retorno[0].estatus === "Erro") {
              throw new Error(response.data.retorno[0].msgErro);
            }
          }

          let dados = await response.data.ttMovimento;
          //console.log(dados);
          this.empregado1 = [];
          this.empregado2 = [];

          dados.forEach((el) => {
            if (dados[0].codEmpregado == el.codEmpregado) {
              this.empregado1.push(el);
            } else {
              this.empregado2.push(el);
            }
          });

          //------------------------------------------------------------------

          this.proventos = this.empregado1.filter((obj) => {
            return obj.indicador === "Provento";
          });

          this.totalProventos = this.proventos[0].vlrTotProventos;

          this.descontos = this.empregado1.filter((obj) => {
            return obj.indicador === "Desconto";
          });

          this.totalDescontos = this.descontos.length > 0 ? this.descontos[0].vlrTotDescontos : 0;
          this.totalLiquido = this.empregado1[0].vlrTotProventos - this.empregado1[0].vlrTotDescontos;
          this.baseFGTS  = this.empregado1[0].vlrBaseFGTS
          this.valorFGTS = this.empregado1[0].vlrFGTS

          if (this.empregado2.length > 0) {
            this.proventos2 = this.empregado2.filter((obj) => {
              return obj.indicador === "Provento";
            });

            this.totalProventos2 = this.proventos2[0].vlrTotProventos;

            this.descontos2 = this.empregado2.filter((obj) => {
              return obj.indicador === "Desconto";
            });

            this.totalDescontos2 =
              this.descontos.length > 0
                ? this.descontos2[0].vlrTotDescontos
                : 0;

            this.totalLiquido2 =
              this.empregado2[0].vlrTotProventos -
              this.empregado2[0].vlrTotDescontos;
          }

          //------------------------------------------------------------------

          this.receiptBase64PDF = this.empregado1[0].anexo;
          this.comissao = this.empregado1[0].comissao;
          this.planoSaude = this.empregado1[0].planoSaude;
          if (this.empregado2.length > 0) {
            this.receiptBase64PDF2 = this.empregado2[0].anexo;
          }
          this.loading = false;

          //------------------------------------------------------------------

          /*           this.proventos = response.data.ttMovimento.filter((obj) => {
            return obj.indicador === "Provento";
          });

          this.totalProventos = this.proventos[0].vlrTotProventos;

          this.descontos = response.data.ttMovimento.filter((obj) => {
            return obj.indicador === "Desconto";
          });

          this.totalDescontos =
            this.descontos.length > 0 ? this.descontos[0].vlrTotDescontos : 0;

          this.totalLiquido =
            response.data.ttMovimento[0].vlrTotProventos -
            response.data.ttMovimento[0].vlrTotDescontos;

          this.receiptBase64PDF = response.data.ttMovimento[0].anexo;

          this.loading = false; */
        } else {
          throw new Error();
        }
      } catch (e) {
        if (codTipoCalculo === 60) {
          this.getReceipt(mes, ano, 61);
        } else {
          this.loading = false;
          this.setErrorMessage(e.message);
        }
      }
    },
    setErrorMessage(errorMessage) {
      this.showError = true;
      this.errorMessage = errorMessage;
    },
    cleanErrorMessage() {
      this.showError = false;
      this.errorMessage = "";
    },
    populateFilers(qtdMeses, disregardedRange) {
      const dateStart = moment().add(disregardedRange, "y");
      const dateEnd = moment()
        .add(disregardedRange, "y")
        .add(qtdMeses, "month");

      while (dateEnd.diff(dateStart, "month") <= 0) {
        this.filterOptions.push({
          mes: dateStart.format("M"),
          ano: dateStart.format("YYYY"),
          descricao: dateStart.format("MMM") + "/" + dateStart.format("YYYY"),
        });
        dateStart.add(-1, "month");
      }
    },
    popularFiltros(periodos) {
      this.filterOptions = [];

      if (periodos[0].codTipoCalculo == 40) {
        periodos.forEach((element) => {
          let periodo = moment(element.dtCompetencia);
          this.filterOptions.push({
            dia: parseInt(periodo.format("DD")),
            mes: parseInt(periodo.format("MM")),
            ano: parseInt(periodo.format("YYYY")),
            descricao:
              periodo.format("DD") +
              "/" +
              periodo.format("MM") +
              "/" +
              periodo.format("YYYY"),
          });
        });
      } else {
        periodos.forEach((element) => {
          let periodo = moment(element.dtCompetencia);

          this.filterOptions.push({
            mes: periodo.format("M"),
            ano: periodo.format("YYYY"),
            descricao: periodo.format("MMM") + "/" + periodo.format("YYYY"),
          });
        });
      }
    },
    getBase64PDF() {
      return this.receiptBase64PDF;
    },
    getBase64PDF2() {
      return this.receiptBase64PDF2;
    },
    getBase64PDFComissao() {
      return this.comissao;
    },
    getBase64PDFPlanoSaude() {
      return this.planoSaude;
    },
    mostraDetalhamento(item) {
      const detalhamento = item.detalhamento.split(String.fromCharCode(1));
      this.detalhamentos = detalhamento;
      this.dialogDetalhamento = true;
    },
  },
};
</script>

<style scoped>
.text-dados-titulo {
  font-size: 1.5em;
  font-weight: bold;
}

.text-dados-sub-titulo {
  font-size: 1.2em;
  font-weight: bold;
}

.text-filters {
  font-size: 0.9em;
  font-weight: bold;
}

.proventos {
  color: green;
}

.descontos {
  color: red;
}

.liquido {
  color: blue;
}

.baseFGTS {
  color: orange;
}

.valorFGTS {
  color: orange;
}

.text-dados {
  font-size: 1.2em;
}
</style>
